/**
 * Player template.
 */
import Container from '@components/atoms/container/playerContainer';
import Pilot from '@components/sections/pilot/pilot';
import Player from '@components/elements/mediaPlayer/playerSelector';
import Spinner from '@components/elements/spinner/spinner';
import { PlayerTemplateProps as Props } from '@shared/types/props/player';

/**
 * Main player template component for VOD content playback.
 * Manages player state, keyboard interactions, floating menu, pilot overlay, and pause ads.
 * Handles bookmarking, keep watching functionality, and parental controls.
 */
export default function PlayerTemplate({ display, callbacks, props }: Props) {
  return (
    <Container {...props.container} {...callbacks.container}>
      {display.ui ? <Pilot {...props.pilot} /> : null}
      {display.spinner ? <Spinner /> : null}
      {display.player ? <Player {...props.player} /> : null}
    </Container>
  );
}
